import { render, staticRenderFns } from "./DisplaySidebar.vue?vue&type=template&id=05e43f3d&scoped=true&"
import script from "./DisplaySidebar.vue?vue&type=script&lang=js&"
export * from "./DisplaySidebar.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySidebar.vue?vue&type=style&index=0&id=05e43f3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e43f3d",
  null
  
)

component.options.__file = "DisplaySidebar.vue"
export default component.exports